
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'default-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input-value'],

	data() {
		return {
			text: ''
		};
	},

	methods: {
		inputValue() {
			if (!this.text) return;
			this.$emit('input-value', this.text);

			this.text = '';
		}
	}
});
